export default "__VITE_ASSET__DNx4Ygb1__"